import {
  CONTENT_LIB_SET_CHANNELS_ACTION,
  CONTENT_LIB_SET_SEARCH_FILTER_ACTION,
  CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_EXIST_ACTION,
  IContentLibChannel,
  IContentLibSearchFilter,
  IContentLibSetChannelsAction,
  IContentLibSetSearchFilterAction,
  IContentLibSetVideosSearchResultAction
} from './types';

export class ContentLibActions {

  public static setVideosSearchResultExist(
    exist: boolean
  ): IContentLibSetVideosSearchResultAction {
    return {
      type: CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_EXIST_ACTION,
      exist,
    }
  }

  public static setSearchFilter(
    searchFilter: Partial<IContentLibSearchFilter>
  ): IContentLibSetSearchFilterAction {
    return {
      type: CONTENT_LIB_SET_SEARCH_FILTER_ACTION,
      searchFilter
    }
  }

  public static setChannels (
    channels: IContentLibChannel[]
  ): IContentLibSetChannelsAction {
    return {
      type: CONTENT_LIB_SET_CHANNELS_ACTION,
      channels,
    }
  }

}
